module.exports = __webpack_public_path__ + "img/instagram-logo.34dd3785.png";